import API from '../http'

/**
 *
 * 企业列表
 * @param params
 * @returns
 */
export const CompanyList = (params: any) => {
  return API.POST('/itg/admin/corp/list/search', params)
}

/**
 *
 * 企业详情
 * @param params
 * @returns
 */
export const CompanyDetail = (params: any) => {
  return API.POST('/itg/admin/corp/' + params.corpId, params)
}


/**
 *
 * 企业流程编辑
 * @param params
 * @returns
 */
export const FlowEdit = (params: any) => {
  return API.POST('/itg/admin/flow/save', params)
}

/**
 *
 * 企业流程列表
 * @param params
 * @returns
 */
export const FlowList = (params: any) => {
  return API.POST('/itg/admin/flow/page', params)
}

/**
 *
 * 企业流程详情
 * @param params
 * @returns
 */
export const FlowDetail = (params: any) => {
  return API.GET('/itg/admin/flow/getInfo', params)
}

/**
 *
 * 企业流程是否启用
 * 0 停用
 * 1 启用
 * @param params
 * @returns
 */
export const FlowEnabled = (params: any) => {
  return API.POST('/itg/admin/flow/enable', params)
}

/**
 *
 * 企业流程删除
 * @param params
 * @returns
 */
export const FlowDelete = (params: any) => {
  return API.POST('/itg/admin/flow/delete', params)
}

/**
 *
 * 企业流程执行
 * @param params
 * @returns
 */
export const FlowStart = (params: any) => {
  return API.POST('/itg/admin/flow/execute', params)
}

/**
 *
 * 企业流程日志分表月份清单
 * @param params
 * @returns
 */
export const FlowLogCreateMonthList = (params: any) => {
  return API.POST('/itg/admin/flow/logCreateMonth', params)
}

/**
 *
 * 企业流程日志
 * @param params
 * @returns
 */
export const FlowLogList = (params: any) => {
  return API.POST('/itg/admin/flow/log', params)
}

/**
 *
 * 企业流程步骤日志
 * @param params
 * @returns
 */
export const FlowLogTaskList = (params: any) => {
  return API.POST('/itg/admin/flow/logDetail', params)
}

/**
 *
 * 企业流程步骤日志1
 * @param params
 * @returns
 */
export const FlowLogById = (params: any) => {
  return API.POST('/itg/admin/flow/logDetailById', params)
}

